/* eslint-disable react-hooks/exhaustive-deps */

import { FC, useEffect, useState } from 'react';
import { AuthModalProps } from './AuthModal.types';

import { StyledModal } from './AuthModal.styles';
import triggerTracking from '@blueprint/tracking/dist/Tracking';
const signInModalHeadingTn = 'Save properties';
import { useDispatch } from 'react-redux';
import { setLoggedIn } from 'reducers/user';
import Preferences from './Preferences';
import { RegTabs } from './RegTabs/RegTabs';
import { useUser } from 'shared/hooks/useUser';
import { User } from 'graphql.generated';
import { isNewUser } from './utils/isNewUser';

export const AuthModal: FC<AuthModalProps> = (props) => {
    const [currentStep, setCurrentStep] = useState(0);
    const { registered } = useUser();

    const {
        heading,
        isShowing,
        close,
        actionAfterAuth,
        resetActionAfterAuth = () => null
    } = props;

    const reduxDispatch = useDispatch();

    const socialAuthSignIn = async () => {
        reduxDispatch(setLoggedIn(true));
        await actionAfterAuth?.action();
        resetActionAfterAuth();
    };

    const socialAuthSignInAndClose = async () => {
        socialAuthSignIn();
        close();
    };

    const socialAuth = (user?: User) => {
        if (isNewUser({ registered }, user)) {
            setCurrentStep(1);
            return;
        }

        socialAuthSignInAndClose();
    };

    // This runs when the user clicks the close button, outside the modal or uses the Escape key (not on submit)
    const toggleClosed = () => {
        triggerTracking({
            event: 'GAEvent',
            eventCategory: 'registration',
            eventAction: 'form closed',
            eventLabel:
                currentStep === 1
                    ? `${actionAfterAuth?.eventLabel}_step_2`
                    : actionAfterAuth?.eventLabel
        });
        currentStep === 1 ? socialAuthSignIn() : resetActionAfterAuth();
        close();
    };

    const registration = <RegTabs {...props} onSocialAuth={socialAuth} />;

    const steps = [
        { title: heading || signInModalHeadingTn, component: registration },
        {
            component: (
                <Preferences
                    close={socialAuthSignInAndClose}
                    actionAfterAuth={actionAfterAuth}
                />
            )
        }
    ];

    useEffect(() => {
        if (isShowing) {
            triggerTracking({
                event: 'GAEvent',
                eventCategory: 'registration',
                eventAction: 'form shown',
                eventLabel: actionAfterAuth?.eventLabel
            });
        } else {
            setCurrentStep(0);
        }
    }, [isShowing]);

    return (
        <StyledModal
            isShowing={isShowing}
            close={toggleClosed}
            modalTitle={steps[currentStep].title}
        >
            {steps[currentStep].component}
        </StyledModal>
    );
};

export default AuthModal;
